import { CssBaseline } from '@material-ui/core';
import { createGenerateClassName, StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import * as env from 'src/lib/env';

const generateClassName = createGenerateClassName({
  disableGlobal: env.getAppEnv() !== 'development',
});

const propTypes = {
  theme: PropTypes.shape().isRequired,
  children: PropTypes.node.isRequired,
};

const defaultProps = {};

const ThemeAndStylesProvider = ({ theme, children }) => {
  return (
    <ThemeProvider theme={theme}>
      <StylesProvider generateClassName={generateClassName}>
        <CssBaseline />

        {children}
      </StylesProvider>
    </ThemeProvider>
  );
};

ThemeAndStylesProvider.propTypes = propTypes;
ThemeAndStylesProvider.defaultProps = defaultProps;

export default ThemeAndStylesProvider;
